import { render, staticRenderFns } from "./MultipleSimplePoints.vue?vue&type=template&id=a5fcead6&scoped=true&"
import script from "./MultipleSimplePoints.vue?vue&type=script&lang=ts&"
export * from "./MultipleSimplePoints.vue?vue&type=script&lang=ts&"
import style0 from "./MultipleSimplePoints.vue?vue&type=style&index=0&id=a5fcead6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5fcead6",
  null
  
)

export default component.exports